import { GET_VARIABLES } from '../actions/types'

const initialState = []

const variablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VARIABLES:
      return action.payload
    default:
      return state
  }
}

export default variablesReducer
